import React from "react"

import "bootstrap/dist/css/bootstrap.min.css"

import Layout from "../components/layout"
import SEO from "../components/seo"

//Parts
import Hero from "./../components/hero/Hero"
import Reto from "../components/reto/Reto"
import Premios from "../components/premios/Premios"
import Beneficios from "../components/beneficios/Beneficios"
import Buy from "../components/buy/Buy"
import Results from "../components/results/Results"

import ImageMeta from '../images/hero.png';

const IndexPage = () => {

  return (
    <Layout>
      <SEO title="Curso - Reto - Cyberpunk"/>
      <Hero/>
    </Layout>
  )
}

export default IndexPage
